module.exports = __webpack_public_path__ + "img/DSC_2764.b93f07df.png";